import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';

import { type DateRange } from '~/types/common';

import { dayjs } from '~/utils/datetime';
import { dateFull, LOCALE_INFO } from '~/utils/l10n';

type P = {
  readonly isDisabled?: boolean;
  readonly maxDate?: Date;
  readonly onChange: (value: DateRange) => void;
  readonly value: DateRange;
};

export const DateRangePicker = ({
  isDisabled,
  maxDate,
  onChange,
  value = [undefined, undefined],
}: P) => {
  const { t } = useTranslation('forms');

  return (
    <LocalizationProvider
      adapterLocale={LOCALE_INFO.name}
      dateAdapter={AdapterDayjs}
    >
      <MuiDateRangePicker
        calendars={3}
        currentMonthCalendarPosition={2}
        dayOfWeekFormatter={(day) => day.format('dd')}
        disabled={isDisabled}
        format={dateFull}
        localeText={{
          start: t(($) => $.date.range.from, {
            ns: 'forms',
          }),
          end: t(($) => $.date.range.to, {
            ns: 'forms',
          }),
        }}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        slotProps={{
          textField: {
            InputProps: {
              className: 'w-36',
            },
          },
        }}
        value={[dayjs(value[0]) || null, dayjs(value[1]) || null]}
        onChange={(newValue) => {
          onChange([newValue[0]?.toDate(), newValue[1]?.toDate()]);
        }}
      />
    </LocalizationProvider>
  );
};
